var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.909,14a.913.913,0,0,1,0-1.826H19.091a.913.913,0,0,1,0,1.826Zm0-6.087a.913.913,0,0,1,0-1.826H19.091a.913.913,0,0,1,0,1.826Zm0-6.087A.913.913,0,0,1,.909,0H19.091a.913.913,0,0,1,0,1.826Z",
    fill: "#eff1f3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.13fd81e9946d18da7c1f79403bc68071.svg";
export { ForwardRef as ReactComponent };